import { i18n } from '@/utils/i18n/vueI18n';

/**
 * Resolves a translated field value for the current user locale.
 * Falls back through: current locale → English → German → first available value.
 */
export function resolveTranslation(
  translations: Record<string, string> | null | undefined,
  fallback = '',
): string {
  if (!translations) {
    return fallback;
  }

  const locale = i18n.global.locale.value;

  return (
    translations[locale] ||
    translations['en'] ||
    translations['de'] ||
    Object.values(translations)[0] ||
    fallback
  );
}
